// extracted by mini-css-extract-plugin
export default {"text":"SubHeading_text__4FE4M","container":"SubHeading_container__Tagqn"};